import { p, _, F, r as register } from "./hooks.module-Cc20K0Ba.js";
import { g, w } from "./preact.module-B5ZnQuyU.js";
import { f as formatMoney } from "./currency-DRNmrEpZ.js";
function MiniCartHeaderButton({
  openDrawer,
  cartData,
  isWhiteMode = false
}) {
  var _a;
  const nonPfandItems = (_a = cartData == null ? void 0 : cartData.items) == null ? void 0 : _a.filter(
    (item) => item.title !== "Pfand"
  );
  const totalItemCount = nonPfandItems == null ? void 0 : nonPfandItems.reduce(
    (total, item) => total + item.quantity,
    0
  );
  const iconKey = isWhiteMode ? "basket_white" : "basket";
  const icons = window.themeVars.icons;
  const iconHtml = icons[iconKey];
  return /* @__PURE__ */ g(
    "button",
    {
      onClick: openDrawer,
      className: "minicart__toggle",
      "aria-label": window.themeVars.strings.accessibility.cartOpen
    },
    /* @__PURE__ */ g(
      "span",
      {
        className: "minicart__toggle-icon",
        dangerouslySetInnerHTML: { __html: iconHtml }
      }
    ),
    Boolean(totalItemCount) && /* @__PURE__ */ g(
      "span",
      {
        className: "\n          minicart__toggle-count\n          text-xs-body\n        "
      },
      totalItemCount
    )
  );
}
function MiniCartHeader({ closeDrawer }) {
  return /* @__PURE__ */ g("div", { className: "minicart__header" }, /* @__PURE__ */ g(
    "p",
    {
      className: "\n        minicart__header-title\n        heading-3\n      "
    },
    window.themeVars.strings.cart.basket
  ), /* @__PURE__ */ g(
    "button",
    {
      className: "minicart__close",
      "aria-label": window.themeVars.strings.cart.cartClose,
      type: "button",
      onClick: closeDrawer
    },
    /* @__PURE__ */ g(
      "span",
      {
        className: "minicart__close-icon",
        dangerouslySetInnerHTML: { __html: window.themeVars.icons.close }
      }
    )
  ));
}
function MiniCartPrice({ price, compareAtPrice }) {
  return /* @__PURE__ */ g("div", { className: "minicart__price-wrapper" }, Number(compareAtPrice) > Number(price) && /* @__PURE__ */ g("div", { className: "price__sale" }, /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.product.price.sale), /* @__PURE__ */ g(
    "span",
    {
      className: "\n            price__item\n            price__item--sale\n            price__item--last\n            text-md-body--semi-bold\n          "
    },
    formatMoney(price)
  ), /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.product.price.sale), /* @__PURE__ */ g("span", null, /* @__PURE__ */ g(
    "span",
    {
      className: "\n              price__item\n              price__item--regular\n            "
    },
    formatMoney(compareAtPrice)
  ))), Number(compareAtPrice) <= Number(price) && /* @__PURE__ */ g("div", { className: "price__regular" }, /* @__PURE__ */ g("span", null, /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.product.price.regular), /* @__PURE__ */ g(
    "span",
    {
      className: "\n              price__item\n              price__item--regular\n              text-md-body--semi-bold\n            "
    },
    formatMoney(price)
  ))));
}
function getVariantMetafieldData(variantId) {
  const url = `https://${window.themeVars.store.permanent_domain}/api/${window.themeVars.config.storefrontApiVersion}/graphql`;
  const query = `
  query {
    node(id: "gid://shopify/ProductVariant/${variantId}") {
      ... on ProductVariant {
        id
        title
        metafields(identifiers: [
          {namespace: "brewdog", key: "max_quantity"},
          {namespace: "brewdog", key: "minimum_quantity"},
          {namespace: "brewdog", key: "parent_product_handle"}
        ]) {
          key
          value
        }
      }
    }
  }
`;
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Shopify-Storefront-Access-Token": window.themeVars.config.storefrontAccessToken
    },
    body: JSON.stringify({ query })
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  }).then((data) => {
    var _a;
    if (data.errors) {
      console.error("GraphQL Errors:", data.errors);
      throw new Error("GraphQL query failed");
    }
    return (_a = data == null ? void 0 : data.data) == null ? void 0 : _a.node;
  }).catch((error) => {
    console.error("Error fetching variant data:", error);
    return null;
  });
}
function MiniCartItem({
  item,
  methods = {
    increaseQuantity: () => {
    },
    decreaseQuantity: () => {
    },
    removeItem: () => {
    }
  },
  metafields = []
}) {
  const { increaseQuantity, decreaseQuantity, removeItem } = methods;
  const [product, setProduct] = p(null);
  const [variant, setVariant] = p(null);
  const [maxQuantity, setMaxQuantity] = p(1);
  const [minQuantity, setMinQuantity] = p(1);
  const [parentProductHandle, setParentProductHandle] = p(
    null
  );
  const [errorMessage, setErrorMessage] = p(null);
  _(() => {
    async function fetchProductData() {
      const response = await fetch(`/products/${item.handle}.js`);
      const data = await response.json();
      setProduct(data);
    }
    fetchProductData();
  }, [item.handle]);
  const maxPreOrderQuantity = metafields.find(
    (field) => field.key === "maximum_quantity"
  );
  const minPreOrderQuantity = metafields.find(
    (field) => field.key === "minimum_quantity"
  );
  _(() => {
    async function fetchVariantData() {
      var _a, _b, _c;
      let variantId = item.variant_id;
      if (item.properties && typeof item.properties["_variant_id"] === "string") {
        variantId = item.properties["_variant_id"];
      }
      const variantData = await getVariantMetafieldData(variantId);
      if (!variantData) {
        console.error("No variant data received for ID:", variantId);
        return;
      }
      const maxQuantityMetafield = (_a = variantData == null ? void 0 : variantData.metafields) == null ? void 0 : _a.find(
        (metafield) => metafield && metafield.key === "max_quantity"
      );
      const maxQty = (maxPreOrderQuantity == null ? void 0 : maxPreOrderQuantity.value) ? parseInt(maxPreOrderQuantity.value) : (maxQuantityMetafield == null ? void 0 : maxQuantityMetafield.value) ? parseInt(maxQuantityMetafield.value) : 100;
      const minQuantityMetafield = (_b = variantData == null ? void 0 : variantData.metafields) == null ? void 0 : _b.find(
        (metafield) => metafield && metafield.key === "minimum_quantity"
      );
      const minQty = (minPreOrderQuantity == null ? void 0 : minPreOrderQuantity.value) ? parseInt(minPreOrderQuantity.value) : (minQuantityMetafield == null ? void 0 : minQuantityMetafield.value) ? parseInt(minQuantityMetafield.value) : 1;
      setMaxQuantity(maxQty);
      setMinQuantity(minQty);
      const parentHandleMetafield = (_c = variantData == null ? void 0 : variantData.metafields) == null ? void 0 : _c.find(
        (metafield) => metafield && metafield.key === "parent_product_handle"
      );
      if (parentHandleMetafield == null ? void 0 : parentHandleMetafield.value) {
        setParentProductHandle(("/products/" + parentHandleMetafield.value).replace(/\/\//g, "/"));
      }
    }
    fetchVariantData();
  }, [item.variant_id, item.properties]);
  const findPreOrderItem = (array) => {
    const preOrderRegex = /pre-order/i;
    return array.find((item2) => preOrderRegex.test(item2));
  };
  const handleQuantityIncrease = (item2) => {
    if (item2.quantity >= maxQuantity) {
      if (!errorMessage) {
        setErrorMessage(
          `${window.themeVars.strings.product.maxQuantityReached.replace("&#39;", "'")} ${item2.title}`
        );
        setTimeout(() => setErrorMessage(null), 3e3);
      }
      return;
    }
    increaseQuantity(item2.id, item2.quantity, maxQuantity);
    const swatches = document.getElementById("swatches");
    if (swatches) {
      const variantQuantityInput = swatches.querySelector(
        `[name='quantity'][data-id='${item2.variant_id}']`
      );
      if (variantQuantityInput) {
        variantQuantityInput.max = (parseInt(variantQuantityInput.max) - 1).toString();
      }
    }
  };
  const handleQuantityDecrease = (item2) => {
    if (item2.quantity <= minQuantity) {
      return;
    }
    decreaseQuantity(item2.id, item2.quantity, minQuantity);
    const swatches = document.getElementById("swatches");
    if (swatches) {
      const variantQuantityInput = swatches.querySelector(
        `[name='quantity'][data-id='${item2.variant_id}']`
      );
      if (variantQuantityInput) {
        variantQuantityInput.max = (parseInt(variantQuantityInput.max) + 1).toString();
      }
    }
  };
  let preOrderTag;
  let preOrderDate;
  let showPreOrderMessage = false;
  if (product) {
    preOrderTag = findPreOrderItem(product.tags);
    const currentVariant = product.variants.find(
      (variant2) => variant2.id === item.variant_id
    );
    if (currentVariant) {
      setVariant(currentVariant);
    }
  }
  if (preOrderTag) {
    preOrderDate = preOrderTag.split(":")[1];
  }
  if (preOrderTag && (variant == null ? void 0 : variant.available)) {
    showPreOrderMessage = true;
  }
  const isStaff = window.themeVars.customer.staff;
  const staffDiscount = window.themeVars.customer.staffDiscount;
  let showStaffMessaging = false;
  const isEfpMember = window.themeVars.customer.efpMember;
  const efpDiscount = window.themeVars.customer.efpDiscount;
  let comparePrice = null;
  const price = item.line_price;
  let showEfpMessaging = false;
  if (variant) {
    comparePrice = Number(variant.compare_at_price) * item.quantity;
  }
  if (isStaff && staffDiscount && !comparePrice) {
    showStaffMessaging = true;
  } else if (isEfpMember && efpDiscount && !comparePrice) {
    showEfpMessaging = true;
  }
  typeof item.properties._proof === "string" && (item.image = item.properties._proof);
  const isPersonalisedCan = typeof item.properties._proof === "string";
  const imageClass = isPersonalisedCan ? "minicart__item-image minicart__item-image--proof" : "minicart__item-image";
  let isPfandCharge = false;
  const lowercaseProductTitle = item.title.toLowerCase();
  if (lowercaseProductTitle.includes("pfand")) {
    isPfandCharge = true;
  }
  const LinkTag = isPfandCharge ? "div" : "a";
  return /* @__PURE__ */ g("div", { className: "minicart__item" }, /* @__PURE__ */ g(
    LinkTag,
    {
      href: isPfandCharge ? void 0 : parentProductHandle ? parentProductHandle : item.url,
      className: "minicart__item-image-column"
    },
    /* @__PURE__ */ g("img", { src: item.image, alt: item.title, className: imageClass })
  ), /* @__PURE__ */ g("div", { className: "minicart__item-info" }, /* @__PURE__ */ g("div", { className: "minicart__item-info-top" }, /* @__PURE__ */ g("div", { className: "minicart__item-info-top-left" }, /* @__PURE__ */ g(
    LinkTag,
    {
      href: isPfandCharge ? void 0 : parentProductHandle ? parentProductHandle : item.url,
      className: "minicart__item-title heading-4"
    },
    item.product_title
  ), /* @__PURE__ */ g("div", { className: "minicart__item-options" }, !item.product_has_only_default_variant && item.options_with_values.map(
    (option) => /* @__PURE__ */ g(
      "p",
      {
        key: option.name,
        className: "minicart__item-option text-sm-body"
      },
      option.value
    )
  ), !isPersonalisedCan && /* @__PURE__ */ g("span", null, Object.entries(item.properties).map(([key, value]) => {
    if (key.startsWith("_")) {
      return null;
    }
    const numericValue = typeof value === "string" ? parseFloat(value.replace(",", ".")) : 0;
    const formattedValue = key === "Pfand" ? formatMoney(numericValue * 100) : value;
    document.createTextNode(key);
    return /* @__PURE__ */ g("p", { className: `cart-item__option text-sm-body cart-item__option-key--${key.replace(/\s+/g, "-").toLowerCase()}`, key }, /* @__PURE__ */ g("div", { className: "minicart__item-option-key" }, "zzgl. ", key, ":"), " ", /* @__PURE__ */ g("div", { className: "minicart__item-option-value" }, formattedValue));
  })))), /* @__PURE__ */ g("div", { className: "minicart__item-line", "data-no-stock-message": "" }, /* @__PURE__ */ g(
    MiniCartPrice,
    {
      price: price.toString(),
      compareAtPrice: comparePrice || ""
    }
  ))), !isPfandCharge && /* @__PURE__ */ g(w, null, showStaffMessaging ? /* @__PURE__ */ g("div", { className: "minicart__staff-discount" }, /* @__PURE__ */ g(
    "span",
    {
      dangerouslySetInnerHTML: {
        __html: window.themeVars.icons.checkmark
      }
    }
  ), /* @__PURE__ */ g("p", { className: "text-xs-body--semi-bold" }, window.themeVars.strings.cart.staffDiscountApplied)) : showEfpMessaging ? /* @__PURE__ */ g("div", { className: "minicart__equity-discount" }, /* @__PURE__ */ g(
    "span",
    {
      dangerouslySetInnerHTML: {
        __html: window.themeVars.icons.checkmark
      }
    }
  ), /* @__PURE__ */ g("p", { className: "text-xs-body--semi-bold" }, window.themeVars.strings.cart.equityDiscountApplied)) : null, showPreOrderMessage && /* @__PURE__ */ g("div", { className: "minicart__pre-order" }, /* @__PURE__ */ g("div", { className: "minicart__pre-order-badge" }, /* @__PURE__ */ g("p", { className: "text-xs-body--semi-bold" }, window.themeVars.strings.cart.preOrder)), preOrderDate && /* @__PURE__ */ g("p", { className: "minicart__pre-order-message text-sm-body--semi-bold" }, window.themeVars.strings.cart.preOrderShipDate.replace(
    "{{ date }}",
    preOrderDate
  )))), isPersonalisedCan && /* @__PURE__ */ g("div", { style: { width: "100%", marginBottom: "8px", paddingLeft: "0", clear: "both" } }, /* @__PURE__ */ g("span", { className: "text-s-body cart-item__personalisation-options" }, item.properties.name, ", ", item.properties.message)), !isPfandCharge && /* @__PURE__ */ g("div", { className: "minicart__item-info-bottom" }, !item.properties.free_gift && /* @__PURE__ */ g("div", { className: "minicart__actions" }, /* @__PURE__ */ g("div", { className: "minicart__quantity" }, /* @__PURE__ */ g(
    "button",
    {
      onClick: () => handleQuantityDecrease(item),
      type: "button",
      className: "minus",
      style: {
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      dangerouslySetInnerHTML: {
        __html: window.themeVars.icons.minus
      }
    }
  ), /* @__PURE__ */ g(
    "input",
    {
      type: "number",
      step: "1",
      min: minQuantity,
      max: maxQuantity,
      readOnly: true,
      name: "quantity",
      value: item.quantity,
      title: "Qty",
      className: "quantity text-lg-body--semi-bold"
    }
  ), /* @__PURE__ */ g(
    "button",
    {
      onClick: () => handleQuantityIncrease(item),
      type: "button",
      className: "plus",
      style: {
        borderRadius: "50%",
        width: "30px",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      },
      dangerouslySetInnerHTML: {
        __html: window.themeVars.icons.plus
      }
    }
  ))), /* @__PURE__ */ g(
    "button",
    {
      onClick: () => removeItem(item.id),
      className: "minicart__delete"
    },
    /* @__PURE__ */ g(
      "span",
      {
        className: "minicart__delete-icon",
        dangerouslySetInnerHTML: {
          __html: window.themeVars.icons.delete
        }
      }
    ),
    /* @__PURE__ */ g("span", { className: "visually-hidden" }, window.themeVars.strings.cart.remove)
  )), errorMessage && /* @__PURE__ */ g("div", { className: "minicart__item-error-message" }, /* @__PURE__ */ g("span", null, errorMessage)), /* @__PURE__ */ g("div", { className: "minicart__item-info-right" }, isPersonalisedCan && /* @__PURE__ */ g("span", { className: "text-sm-body--semi-bold" }, window.themeVars.personalised_cans.personalised_product_disclaimer))));
}
function MiniCartTotals({ cartData }) {
  var _a;
  const discount = (cartData == null ? void 0 : cartData.total_discount) ?? 0;
  const total = (cartData == null ? void 0 : cartData.total_price) ?? 0;
  const ogTotal = (cartData == null ? void 0 : cartData.original_total_price) ?? 0;
  const showDiscount = discount > 0;
  const enableMinimumCartThreshold = window.themeVars.config.cart.enableMinimumCartThreshold;
  const minimumCartThreshold = window.themeVars.config.cart.minimumCartThreshold;
  let showFreeDeliveryMessage = true;
  if (enableMinimumCartThreshold && total < minimumCartThreshold) {
    showFreeDeliveryMessage = false;
  }
  const pfandChargeItem = (_a = cartData == null ? void 0 : cartData.items) == null ? void 0 : _a.find(
    (item) => item.title === "Pfand"
  );
  const pfandCharge = pfandChargeItem == null ? void 0 : pfandChargeItem.price;
  return /* @__PURE__ */ g("div", { className: "minicart__totals" }, /* @__PURE__ */ g("div", { className: "minicart__totals-row" }, /* @__PURE__ */ g("p", { className: "text-md-body" }, window.themeVars.strings.cart.subtotal), /* @__PURE__ */ g("p", { className: "text-md-body" }, formatMoney(ogTotal, true, true))), pfandCharge && /* @__PURE__ */ g("div", { className: "minicart__totals-row" }, /* @__PURE__ */ g("p", { className: "text-md-body" }, "Pfand"), /* @__PURE__ */ g("p", { className: "text-md-body" }, formatMoney(pfandCharge, true, true))), showFreeDeliveryMessage && /* @__PURE__ */ g("div", { className: "minicart__totals-row" }, /* @__PURE__ */ g("p", { className: "text-md-body" }, window.themeVars.strings.cart.delivery), /* @__PURE__ */ g("p", { className: "text-md-body" }, window.themeVars.strings.cart.free)), showDiscount && /* @__PURE__ */ g("div", { className: "minicart__totals-row" }, /* @__PURE__ */ g("p", { className: "text-md-body" }, window.themeVars.strings.cart.bestDiscountApplied), /* @__PURE__ */ g("p", { className: "text-md-body" }, "- ", formatMoney(discount, true, true))), /* @__PURE__ */ g("div", { className: "minicart__totals-row" }, /* @__PURE__ */ g("p", { className: "text-md-body--semi-bold" }, window.themeVars.strings.cart.total), /* @__PURE__ */ g("p", { className: "text-md-body--semi-bold" }, formatMoney(total, true, true))));
}
function MiniCartThresholdMessage() {
  const minimumCartThreshold = window.themeVars.config.cart.minimumCartThreshold;
  const formattedMinimumCartThreshold = formatMoney(
    minimumCartThreshold,
    true,
    false
  );
  return /* @__PURE__ */ g("div", { className: "minicart__cart-threshold-error" }, /* @__PURE__ */ g(
    "span",
    {
      className: "minicart__cart-threshold-error-icon",
      dangerouslySetInnerHTML: {
        __html: window.themeVars.icons.error
      }
    }
  ), /* @__PURE__ */ g(
    "p",
    {
      className: "\n        minicart__cart-threshold-error-text\n        text-sm-body--semi-bold\n      "
    },
    window.themeVars.strings.cart.cartUnderValue.replace(
      "{{ value }}",
      formattedMinimumCartThreshold
    )
  ));
}
function MiniCartFooter({
  closeDrawer,
  showMinimumCartThresholdMessage,
  showViewBasketButton
}) {
  return /* @__PURE__ */ g(
    "form",
    {
      className: "minicart__footer",
      action: window.themeVars.routes.checkout,
      method: "post"
    },
    showMinimumCartThresholdMessage && /* @__PURE__ */ g(MiniCartThresholdMessage, null),
    /* @__PURE__ */ g("div", { className: "minicart__footer-actions" }, showViewBasketButton && /* @__PURE__ */ g("a", { href: window.themeVars.routes.cart, className: "btn btn-black" }, window.themeVars.strings.cart.viewBasket), /* @__PURE__ */ g(
      "button",
      {
        type: "button",
        onClick: closeDrawer,
        className: "\n            minicart__continue-shopping\n            btn btn--white\n          "
      },
      window.themeVars.strings.cart.continueShopping
    ))
  );
}
function MiniCartRecommendations({
  addItem,
  recommendationProductHandle
}) {
  const [recommendations, setRecommendations] = p([]);
  const recommendationsCount = 3;
  _(() => {
    if (!recommendationProductHandle)
      return;
    const fetchRecommendations = async () => {
      try {
        const metafieldProducts = await fetchMetafieldRelatedProducts();
        if (metafieldProducts && metafieldProducts.length > 0) {
          setRecommendations(metafieldProducts);
          return;
        }
        await fetchRecommendationsAPI();
      } catch (e) {
        console.error("Fetch recommendations error:", e);
        setRecommendations([]);
      }
    };
    const fetchMetafieldRelatedProducts = async () => {
      var _a, _b, _c;
      try {
        const productUrl = `/products/${recommendationProductHandle}.js`;
        const response = await fetch(productUrl);
        if (!response.ok) {
          console.log(
            `Product URL ${productUrl} not found, falling back to recommendations API`
          );
          return null;
        }
        const productData = await response.json();
        const parentHandleMetafield = (_a = productData.metafields) == null ? void 0 : _a.find(
          (metafield) => metafield.namespace === "brewdog" && metafield.key === "parent_product_handle"
        );
        let recommendationSourceHandle = recommendationProductHandle;
        if (parentHandleMetafield == null ? void 0 : parentHandleMetafield.value) {
          const cleanParentHandle = parentHandleMetafield.value.replace(/^\/products\//, "").replace(/^\//, "");
          recommendationSourceHandle = cleanParentHandle;
          const parentProductUrl = `/products/${cleanParentHandle}.js`;
          const parentResponse = await fetch(parentProductUrl);
          if (parentResponse.ok) {
            const parentProductData = await parentResponse.json();
            productData.metafields = parentProductData.metafields;
            console.log(
              `Using parent product ${cleanParentHandle} for recommendations instead of ${recommendationProductHandle}`
            );
          } else {
            console.log(
              `Parent product ${cleanParentHandle} not found, using original product for recommendations`
            );
          }
        }
        const relatedProductsMetafield = (_b = productData.metafields) == null ? void 0 : _b.find(
          (metafield) => metafield.namespace === "shopify--discovery--product_recommendation" && metafield.key === "related_products"
        );
        const cartUpsellMetafield = (_c = productData.metafields) == null ? void 0 : _c.find(
          (metafield) => metafield.namespace === "brewdog" && metafield.key === "cart_upsell_products"
        );
        const selectedMetafield = cartUpsellMetafield || relatedProductsMetafield;
        if (!(selectedMetafield == null ? void 0 : selectedMetafield.value)) {
          return null;
        }
        let relatedProductIds;
        try {
          relatedProductIds = JSON.parse(selectedMetafield.value);
        } catch (e) {
          relatedProductIds = selectedMetafield.value.split(",").map((id) => id.trim());
        }
        if (!(relatedProductIds == null ? void 0 : relatedProductIds.length)) {
          return null;
        }
        const productPromises = relatedProductIds.map(
          async (productId) => {
            if (productId.includes("gid://") || /^\d+$/.test(productId)) {
              const numericId = productId.replace(/\D/g, "");
              const productResponse = await fetch(`/products/${numericId}.js`);
              if (!productResponse.ok) {
                return null;
              }
              return await productResponse.json();
            } else {
              const productResponse = await fetch(`/products/${productId}.js`);
              if (!productResponse.ok) {
                return null;
              }
              return await productResponse.json();
            }
          }
        );
        const products = await Promise.all(productPromises);
        const validProducts = products.filter((product) => product !== null);
        if (validProducts.length === 0) {
          return null;
        }
        const filteredProducts = validProducts.filter(
          (product) => product.available && product.title !== "Pfand" && !isProductSeoHidden(product)
        ).slice(0, recommendationsCount);
        return filteredProducts;
      } catch (error) {
        console.error("Error fetching metafield related products:", error);
        return null;
      }
    };
    const fetchRecommendationsAPI = async () => {
      const productRecommendationsUrl = window.themeVars.routes.product_recommendations_url;
      if (!recommendationProductHandle)
        return;
      try {
        const productResponse = await fetch(
          `/products/${recommendationProductHandle}.js`
        );
        if (!productResponse.ok) {
          console.error("Could not fetch product for recommendations API");
          setRecommendations([]);
          return;
        }
        const productData = await productResponse.json();
        const productId = productData.id;
        const url = `${productRecommendationsUrl}.json?product_id=${productId}&limit=20&intent=related`;
        const response = await fetch(url);
        const data = await response.json();
        const limitProducts = data.products.filter(
          (product) => product.available && product.title !== "Pfand" && !isProductSeoHidden(product)
        ).slice(0, recommendationsCount);
        setRecommendations(limitProducts);
      } catch (e) {
        console.error("Fetch recommendations error:", e);
        setRecommendations([]);
      }
    };
    fetchRecommendations();
  }, [recommendationProductHandle]);
  const isProductSeoHidden = (product) => {
    if (product.tags && product.tags.includes("seo-hidden")) {
      return true;
    }
    if (product.seoHidden === true || product.seoHidden === "1") {
      return true;
    }
    return false;
  };
  if (!recommendationProductHandle || !recommendations.length)
    return null;
  const filteredRecommendations = recommendations.filter(
    (product) => product.type !== "Bundle"
  );
  _(() => {
    filteredRecommendations.forEach((product) => {
      var _a, _b;
      const isOutOfStock = !product.available && ((_a = product.tags) == null ? void 0 : _a.includes("single-variant-out-of-stock"));
      const hasBisEnabled = isOutOfStock && ((_b = product.tags) == null ? void 0 : _b.includes("back-in-stock"));
      if (hasBisEnabled) {
        const bisButton = document.querySelector(
          `[data-bis-trigger][data-product="${product.id}"]`
        );
        const bisPopup = document.querySelector(
          `uwp-product-notify-me[data-product-id="${product.id}"]`
        );
        if (bisButton && bisPopup) {
          const handleBisClick = () => {
            bisPopup.setAttribute("is-visible", "true");
          };
          bisButton.addEventListener("click", handleBisClick);
          return () => {
            bisButton.removeEventListener("click", handleBisClick);
          };
        }
      }
    });
  }, [filteredRecommendations]);
  return /* @__PURE__ */ g("div", { className: "cart-upsell" }, filteredRecommendations.length !== 0 && /* @__PURE__ */ g("div", null, /* @__PURE__ */ g("p", { className: "cart-upsell__title heading-4" }, window.themeVars.strings.cart.loadUpYourBasket), /* @__PURE__ */ g("div", { className: "cart-upsell__product-wrapper" }, filteredRecommendations.map((product) => {
    var _a, _b;
    const firstAvailableVariant = product.variants.find(
      (variant) => variant.available
    );
    if (!firstAvailableVariant) {
      return null;
    }
    const isOutOfStock = !product.available && ((_a = product.tags) == null ? void 0 : _a.includes("single-variant-out-of-stock"));
    const hasBisEnabled = isOutOfStock && ((_b = product.tags) == null ? void 0 : _b.includes("back-in-stock"));
    return /* @__PURE__ */ g(
      "div",
      {
        className: `cart-upsell__product ${isOutOfStock ? "cart-upsell__product--single-variant-out-of-stock" : ""}`,
        key: product.id
      },
      /* @__PURE__ */ g(
        "img",
        {
          src: product.images[0],
          alt: product.title,
          className: `cart-upsell__product-image ${isOutOfStock ? "cart-upsell__product-image--out-of-stock" : ""}`,
          width: "80",
          height: "80"
        }
      ),
      /* @__PURE__ */ g("div", { className: "cart-upsell__product-details" }, isOutOfStock && /* @__PURE__ */ g("span", { className: "cart-upsell__badge badge badge-yellow" }, window.themeVars.strings.product.soldOut), /* @__PURE__ */ g("p", { className: "cart-upsell__product-title heading-4" }, product.title), firstAvailableVariant.title !== "Default Title" && /* @__PURE__ */ g("p", { className: "cart-upsell__product-option text-md-body" }, firstAvailableVariant.title), /* @__PURE__ */ g(
        MiniCartPrice,
        {
          price: firstAvailableVariant.price,
          compareAtPrice: firstAvailableVariant.compare_at_price
        }
      )),
      isOutOfStock ? hasBisEnabled ? /* @__PURE__ */ g(
        "button",
        {
          className: "cart-upsell__product-cta btn btn-white btn-white--outline",
          "data-bis-trigger": true,
          "data-product": product.id,
          "data-variant": firstAvailableVariant.id
        },
        window.themeVars.strings.product.notifyMe
      ) : /* @__PURE__ */ g(
        "button",
        {
          className: "cart-upsell__product-cta btn btn-white btn-white--outline",
          disabled: true
        },
        window.themeVars.strings.product.soldOut
      ) : /* @__PURE__ */ g(
        "button",
        {
          className: "cart-upsell__product-cta",
          onClick: () => addItem(firstAvailableVariant.id),
          dangerouslySetInnerHTML: {
            __html: window.themeVars.icons.addToCart
          }
        }
      ),
      hasBisEnabled && /* @__PURE__ */ g(
        "uwp-product-notify-me",
        {
          "data-product-id": product.id,
          "data-variant-id": "",
          "product-data": JSON.stringify(product),
          "is-visible": "false"
        }
      )
    );
  }))));
}
function MiniCartFreeGift() {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  const giftProductId = (_a = window.themeVars) == null ? void 0 : _a.free_gift.gift_product_id;
  const freeGiftThreshold = (_b = window.themeVars) == null ? void 0 : _b.free_gift.threshold;
  if (!giftProductId) {
    return null;
  }
  return /* @__PURE__ */ g(
    "uwp-free-gift",
    {
      "free-gift-product": giftProductId || "",
      "data-threshold": freeGiftThreshold || "0",
      style: "display: none;"
    },
    /* @__PURE__ */ g("div", { className: "free-gift" }, ((_c = window.themeVars) == null ? void 0 : _c.free_gift.title) && /* @__PURE__ */ g("h3", { className: "free-gift__title" }, (_d = window.themeVars) == null ? void 0 : _d.free_gift.title), ((_e = window.themeVars) == null ? void 0 : _e.free_gift.title_threshold) && /* @__PURE__ */ g(
      "h3",
      {
        className: "\n            free-gift__title-threshold\n            heading-4\n          "
      },
      (_f = window.themeVars) == null ? void 0 : _f.free_gift.title_threshold
    ), ((_g = window.themeVars) == null ? void 0 : _g.free_gift.text) && /* @__PURE__ */ g("p", { className: "free-gift__text" }, (_h = window.themeVars) == null ? void 0 : _h.free_gift.text), giftProductId && /* @__PURE__ */ g("div", { className: "free-gift__product" }, /* @__PURE__ */ g(
      "img",
      {
        className: "free-gift__product-image",
        width: "58",
        height: "58",
        loading: "lazy",
        src: (_i = window.themeVars) == null ? void 0 : _i.free_gift.gift_product_img,
        alt: (_j = window.themeVars) == null ? void 0 : _j.free_gift.gift_product_title
      }
    ), /* @__PURE__ */ g("div", { className: "free-gift__product-content" }, /* @__PURE__ */ g("h3", { className: "free-gift__product-title heading-4" }, (_k = window.themeVars) == null ? void 0 : _k.free_gift.gift_product_title), /* @__PURE__ */ g("p", { className: "free-gift__product-variant" }, (_l = window.themeVars) == null ? void 0 : _l.free_gift.gift_product_variant), /* @__PURE__ */ g("p", { className: "free-gift__product-price" }, /* @__PURE__ */ g("strong", null, "Free"), /* @__PURE__ */ g("span", null, formatMoney((_m = window.themeVars) == null ? void 0 : _m.free_gift.gift_product_price)))), /* @__PURE__ */ g(
      "button",
      {
        className: "free-gift__product-cta",
        "data-add-to-cart": true,
        dangerouslySetInnerHTML: {
          __html: window.themeVars.icons.addToCart
        }
      }
    )))
  );
}
async function fetchProductMetafieldsById(productId) {
  var _a;
  const endpoint = `https://${window.themeVars.store.permanent_domain}/api/${window.themeVars.config.storefrontApiVersion}/graphql`;
  const query = `
  query ProductMetafields($id: ID!) {
    product(id: $id) {
      id
      handle
      title
      metafields(identifiers: [{namespace: "custom", key: "pre_order_information"}]) {
        key
        value
        reference {
          ... on Metaobject {
            id
            type
            fields {
              key
              value
            }
          }
        }
      }
    }
  }
  `;
  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": window.themeVars.config.storefrontAccessToken
    },
    body: JSON.stringify({
      query,
      variables: { id: productId }
    })
  });
  const preOrderData = await response.json();
  return ((_a = preOrderData == null ? void 0 : preOrderData.data) == null ? void 0 : _a.product) || [];
}
function MiniCart(props) {
  var _a, _b, _c;
  const isWhiteMode = props["data-text-color"] === "white";
  const [cartData, setCartData] = p(null);
  const cartRef = F(document.querySelector("uwp-cart"));
  const miniCartDrawerRef = F(null);
  const addToCartNotficationRef = F(null);
  const recommendationProductHandle = ((_a = cartData == null ? void 0 : cartData.items[0]) == null ? void 0 : _a.handle) ?? "";
  const formattedDeliveryMessaging = window.themeVars.config.cart.deliveryMessaging.replace("<p>", '<p class="text-sm-body">').replace("<strong>", '<strong class="text-sm-body--semi-bold">');
  const enableMinimumCartThreshold = window.themeVars.config.cart.enableMinimumCartThreshold;
  const minimumCartThreshold = window.themeVars.config.cart.minimumCartThreshold;
  let showMinimumCartThresholdMessage = false;
  let showViewBasketButton = true;
  const originalTotalPrice = (cartData == null ? void 0 : cartData.original_total_price) ?? 0;
  if (enableMinimumCartThreshold && originalTotalPrice < minimumCartThreshold) {
    showMinimumCartThresholdMessage = true;
    showViewBasketButton = false;
  }
  if (enableMinimumCartThreshold && originalTotalPrice >= minimumCartThreshold) {
    showMinimumCartThresholdMessage = false;
    showViewBasketButton = true;
  }
  if (!enableMinimumCartThreshold) {
    showViewBasketButton = true;
  }
  _(() => {
    const drawerElement = document.querySelector(
      "uwp-drawer[modal-name=mini-cart]"
    );
    if (drawerElement) {
      miniCartDrawerRef.current = drawerElement;
    }
    const addToCartNotificationElement = document.querySelector(
      "uwp-add-to-cart-notification"
    );
    if (addToCartNotificationElement) {
      addToCartNotficationRef.current = addToCartNotificationElement;
    }
  }, []);
  _(() => {
    const cartElement = cartRef.current;
    if (!cartElement) {
      return;
    }
    setCartData(cartElement.cartData);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "cart-data") {
          const updatedData = mutation.target.cartData;
          setCartData(updatedData);
        }
      });
    });
    observer.observe(cartElement, { attributes: true });
    return () => observer.disconnect();
  }, []);
  document.addEventListener("cart:updated", (event) => {
    const customEvent = event;
    setCartData(customEvent.detail);
  });
  document.addEventListener("cart:added", (event) => {
    var _a2, _b2;
    const customEvent = event;
    if (!addToCartNotficationRef.current) {
      return;
    }
    if (((_a2 = customEvent.detail) == null ? void 0 : _a2.token) || ((_b2 = customEvent.detail) == null ? void 0 : _b2.id)) {
      addToCartNotficationRef.current.showNotification();
    }
  });
  const openDrawer = () => {
    if (window.themeVars.store.template === "cart") {
      return;
    }
    const openModals = document.querySelectorAll(
      '.modal.is-open, .drawer.is-open:not([modal-name="mini-cart"]), .desktop-menu__item.is-open'
    );
    openModals.forEach((modal) => {
      if (modal.classList.contains("desktop-menu__item")) {
        modal.classList.remove("is-open");
        const desktopMenu = modal.closest("uwp-desktop-menu");
        if (desktopMenu == null ? void 0 : desktopMenu.closeAllDropdowns) {
          desktopMenu.closeAllDropdowns();
        }
      } else if (modal.classList.contains("modal") || modal.classList.contains("drawer")) {
        const hideMethod = modal.hideModal || modal.hideDrawer;
        if (hideMethod) {
          hideMethod.call(modal);
        }
      }
    });
    if (miniCartDrawerRef.current) {
      miniCartDrawerRef.current.showDrawer();
    } else {
      console.error("miniCartDrawerRef.current is null");
    }
  };
  const closeDrawer = () => {
    const htmlElement = document.querySelector("html");
    if (htmlElement) {
      htmlElement.style.overflow = "";
      htmlElement.style.paddingRight = "";
    } else {
      console.error("HTML element not found");
    }
    if (miniCartDrawerRef.current) {
      miniCartDrawerRef.current.hideDrawer();
    } else {
      console.error("miniCartDrawerRef.current is null");
    }
  };
  const increaseQuantity = (itemId, quantity, max) => {
    if (!cartRef.current) {
      return;
    }
    if (quantity >= max) {
      return;
    }
    cartRef.current.changeItemQuantity(itemId, quantity + 1);
  };
  const decreaseQuantity = (itemId, quantity, min) => {
    if (!cartRef.current) {
      return;
    }
    if (quantity <= min) {
      return;
    }
    cartRef.current.changeItemQuantity(itemId, quantity - 1);
  };
  const removeItem = (itemId) => {
    if (!cartRef.current) {
      return;
    }
    cartRef.current.changeItemQuantity(itemId, 0);
  };
  const addItem = (itemId) => {
    if (!cartRef.current) {
      return;
    }
    cartRef.current.addItem(itemId);
  };
  const [cartMetafields, setCartMetafields] = p([]);
  _(() => {
    var _a2;
    if (!((_a2 = cartData == null ? void 0 : cartData.items) == null ? void 0 : _a2.length)) {
      setCartMetafields([]);
      return;
    }
    async function fetchAllMetafields() {
      const items = cartData.items;
      const allMetafields = await Promise.all(
        items.map(async (item) => {
          const productGid = `gid://shopify/Product/${item.product_id}`;
          const metafields = await fetchProductMetafieldsById(productGid);
          return { itemId: item.id, metafields };
        })
      );
      setCartMetafields(allMetafields);
    }
    fetchAllMetafields();
  }, [cartData]);
  const hasPreOrderItems = !!((_b = cartData == null ? void 0 : cartData.items) == null ? void 0 : _b.some((item) => {
    var _a2, _b2, _c2, _d;
    if (item.title.includes("Pfand"))
      return false;
    const metafieldsEntry = cartMetafields.find(
      (entry) => {
        var _a3;
        return ((_a3 = entry.metafields) == null ? void 0 : _a3.handle) === item.handle;
      }
    );
    const referenceFields = ((_d = (_c2 = (_b2 = (_a2 = metafieldsEntry == null ? void 0 : metafieldsEntry.metafields) == null ? void 0 : _a2.metafields) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.reference) == null ? void 0 : _d.fields) || [];
    const enablePreOrderField = referenceFields.find(
      (field) => field.key === "enable_pre_order"
    );
    const isPreOrder = (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === true || (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === "true";
    return !!isPreOrder;
  }));
  const hasNonPreOrderItems = !!((_c = cartData == null ? void 0 : cartData.items) == null ? void 0 : _c.some((item) => {
    var _a2, _b2, _c2, _d;
    if (item.title.includes("Pfand"))
      return false;
    const metafieldsEntry = cartMetafields.find(
      (entry) => {
        var _a3;
        return ((_a3 = entry.metafields) == null ? void 0 : _a3.handle) === item.handle;
      }
    );
    const referenceFields = ((_d = (_c2 = (_b2 = (_a2 = metafieldsEntry == null ? void 0 : metafieldsEntry.metafields) == null ? void 0 : _a2.metafields) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.reference) == null ? void 0 : _d.fields) || [];
    const enablePreOrderField = referenceFields.find(
      (field) => field.key === "enable_pre_order"
    );
    const isPreOrder = (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === true || (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === "true";
    return !isPreOrder;
  }));
  return /* @__PURE__ */ g(
    "div",
    {
      className: `
        minicart__container
        ${!(cartData == null ? void 0 : cartData.item_count) ? "is-empty" : ""}
      `
    },
    /* @__PURE__ */ g(
      MiniCartHeaderButton,
      {
        openDrawer,
        cartData,
        isWhiteMode
      }
    ),
    window.themeVars.store.template !== "cart" && /* @__PURE__ */ g(
      "uwp-drawer",
      {
        "modal-name": "mini-cart",
        className: "drawer minicart__drawer drawer--right",
        "aria-hidden": "true",
        "drawer-direction": "right",
        ref: miniCartDrawerRef
      },
      /* @__PURE__ */ g("div", { className: "modal__overlay", tabIndex: -1, "data-close-drawer": true }),
      /* @__PURE__ */ g("aside", { className: "drawer__container", role: "dialog", "aria-modal": "true" }, /* @__PURE__ */ g("div", { className: "minicart__main" }, /* @__PURE__ */ g(MiniCartHeader, { closeDrawer }), showMinimumCartThresholdMessage ? /* @__PURE__ */ g(MiniCartThresholdMessage, null) : /* @__PURE__ */ g(
        "uwp-free-shipping-indicator",
        {
          "cart-value": cartData == null ? void 0 : cartData.total_price,
          "show-success-message": "true",
          "text-class": "text-sm-body--semi-bold"
        }
      ), /* @__PURE__ */ g("div", { className: "minicart__body", "js-modal": "scrollElement" }, window.themeVars.config.cart.deliveryMessaging && /* @__PURE__ */ g(
        "div",
        {
          className: "\n                      minicart__delivery-messaging\n                      text-sm-body\n                    ",
          dangerouslySetInnerHTML: {
            __html: formattedDeliveryMessaging
          }
        }
      ), hasPreOrderItems && /* @__PURE__ */ g("div", { className: "minicart__items-list" }, /* @__PURE__ */ g("p", { className: "cart-upsell__title heading-4" }, window.themeVars.strings.cart.preOrder), cartData == null ? void 0 : cartData.items.map((item) => {
        var _a2, _b2, _c2, _d;
        if (item.title.includes("Pfand"))
          return null;
        const metafieldsEntry = cartMetafields.find(
          (entry) => {
            var _a3;
            return ((_a3 = entry.metafields) == null ? void 0 : _a3.handle) === item.handle;
          }
        );
        const referenceFields = ((_d = (_c2 = (_b2 = (_a2 = metafieldsEntry == null ? void 0 : metafieldsEntry.metafields) == null ? void 0 : _a2.metafields) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.reference) == null ? void 0 : _d.fields) || [];
        const enablePreOrderField = referenceFields.find(
          (field) => field.key === "enable_pre_order"
        );
        const isPreOrder = (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === true || (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === "true";
        if (!isPreOrder)
          return null;
        return /* @__PURE__ */ g(
          MiniCartItem,
          {
            methods: {
              increaseQuantity,
              decreaseQuantity,
              removeItem
            },
            key: item.id,
            item,
            metafields: referenceFields
          }
        );
      })), /* @__PURE__ */ g("div", { className: "minicart__items-list" }, hasPreOrderItems && hasNonPreOrderItems && /* @__PURE__ */ g("p", { className: "cart-upsell__title heading-4" }, window.themeVars.strings.cart["deliverNow"]), cartData == null ? void 0 : cartData.items.map((item) => {
        var _a2, _b2, _c2, _d;
        if (item.title.includes("Pfand"))
          return null;
        const metafieldsEntry = cartMetafields.find(
          (entry) => {
            var _a3;
            return ((_a3 = entry.metafields) == null ? void 0 : _a3.handle) === item.handle;
          }
        );
        const referenceFields = ((_d = (_c2 = (_b2 = (_a2 = metafieldsEntry == null ? void 0 : metafieldsEntry.metafields) == null ? void 0 : _a2.metafields) == null ? void 0 : _b2[0]) == null ? void 0 : _c2.reference) == null ? void 0 : _d.fields) || [];
        const enablePreOrderField = referenceFields.find(
          (field) => field.key === "enable_pre_order"
        );
        const isPreOrder = (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === true || (enablePreOrderField == null ? void 0 : enablePreOrderField.value) === "true";
        if (isPreOrder)
          return null;
        return /* @__PURE__ */ g(
          MiniCartItem,
          {
            methods: {
              increaseQuantity,
              decreaseQuantity,
              removeItem
            },
            key: item.id,
            item
          }
        );
      })), cartData && /* @__PURE__ */ g(w, null, /* @__PURE__ */ g(MiniCartFreeGift, null), window.themeVars.config.enableCartRecommendations && /* @__PURE__ */ g(
        MiniCartRecommendations,
        {
          addItem,
          recommendationProductHandle
        }
      )), /* @__PURE__ */ g(MiniCartTotals, { cartData })), /* @__PURE__ */ g("div", { className: "minicart__body--empty" }, /* @__PURE__ */ g("p", { className: "minicart__message" }, window.themeVars.strings.cart.cartEmpty)), /* @__PURE__ */ g(
        MiniCartFooter,
        {
          closeDrawer,
          showMinimumCartThresholdMessage,
          showViewBasketButton
        }
      )))
    )
  );
}
register(MiniCart, "uwp-minicart");
